<template>
  <div class="contact-wrapper">
    <div class="content-wrapper">
      <h1>We’re here to help</h1>
      <p>
        If you’ve got a question about our services, or <br />you’re having
        trouble filling in an online form, contact us by phone or email.
      </p>
      <ul class="contact-methods">
        <!--        <li class="item">-->
        <!--          <div class="icon">-->
        <!--            <img src="@/assets/img/icons/icon-tel.svg" alt="Telephone" />-->
        <!--          </div>-->
        <!--          <h3>-->
        <!--            Give us a call-->
        <!--          </h3>-->
        <!--          <p>-->
        <!--            <a href="tel:03334559960">0333 455 9960</a>-->
        <!--          </p>-->
        <!--        </li>-->
        <li class="item">
          <div class="icon">
            <img src="@/assets/img/icons/icon-email.svg" alt="Email" />
          </div>
          <h3>
            Send us an email
          </h3>
          <p>
            <a
              href="mailto:info@homeowner.loans"
              title="Contact Homeowner.Loans by email"
              >info@homeowner.loans</a
            >
          </p>
        </li>
        <li class="item">
          <div class="icon">
            <img src="@/assets/img/icons/icon-write.svg" alt="Write" />
          </div>
          <h3>
            Write to us
          </h3>
          <p>
            Sequence X Ltd trading as Homeowner.Loans<br />67 Wellgate,<br />Rotherham,<br />South
            Yorkshire,<br />S60 2LT.
          </p>
        </li>
      </ul>
      <ul class="contact-methods full">
        <li class="item">
          <h3>
            Opening Hours
          </h3>
          <p>
            Monday - Thursday: 09:00am - 05:00pm
          </p>
          <p>Friday: 10:00am - 04:00pm</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Contact"
};
</script>
<style lang="scss">
@import "../../scss/partials/contact";
</style>
